// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../builder/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../builder/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) Jupyter Development Team.
 * Distributed under the terms of the Modified BSD License.
 */
.jp-RenderedMermaid {
  overflow: auto;
  display: flex;
}

.jp-RenderedMermaid.jp-mod-warning {
  width: auto;
  padding: 0.5em;
  margin-top: 0.5em;
  border: var(--jp-border-width) solid var(--jp-warn-color2);
  border-radius: var(--jp-border-radius);
  color: var(--jp-ui-font-color1);
  font-size: var(--jp-ui-font-size1);
  white-space: pre-wrap;
  word-wrap: break-word;
}

.jp-RenderedMermaid figure {
  margin: 0;
  overflow: auto;
  max-width: 100%;
}

.jp-RenderedMermaid img {
  max-width: 100%;
}

.jp-RenderedMermaid-Details > pre {
  margin-top: 1em;
}

.jp-RenderedMermaid-Summary {
  color: var(--jp-warn-color2);
}

.jp-RenderedMermaid:not(.jp-mod-warning) pre {
  display: none;
}

.jp-RenderedMermaid-Summary > pre {
  display: inline-block;
  white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@jupyterlab/mermaid/style/base.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,0DAA0D;EAC1D,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":["/*\n * Copyright (c) Jupyter Development Team.\n * Distributed under the terms of the Modified BSD License.\n */\n.jp-RenderedMermaid {\n  overflow: auto;\n  display: flex;\n}\n\n.jp-RenderedMermaid.jp-mod-warning {\n  width: auto;\n  padding: 0.5em;\n  margin-top: 0.5em;\n  border: var(--jp-border-width) solid var(--jp-warn-color2);\n  border-radius: var(--jp-border-radius);\n  color: var(--jp-ui-font-color1);\n  font-size: var(--jp-ui-font-size1);\n  white-space: pre-wrap;\n  word-wrap: break-word;\n}\n\n.jp-RenderedMermaid figure {\n  margin: 0;\n  overflow: auto;\n  max-width: 100%;\n}\n\n.jp-RenderedMermaid img {\n  max-width: 100%;\n}\n\n.jp-RenderedMermaid-Details > pre {\n  margin-top: 1em;\n}\n\n.jp-RenderedMermaid-Summary {\n  color: var(--jp-warn-color2);\n}\n\n.jp-RenderedMermaid:not(.jp-mod-warning) pre {\n  display: none;\n}\n\n.jp-RenderedMermaid-Summary > pre {\n  display: inline-block;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
